module.exports = __webpack_public_path__ + "img/sc.ccf2e303.svg";